module.exports = __webpack_public_path__ + "static/media/IMG_7064.73b82b42.jpg";